<nav v-if="is_onboarding_system" class="navbar navbar-expand-lg bg-white border-bottom px-3 px-lg-4 py-0 onboarding-top-navbar">
  <div class="container-fluid px-0 d-flex align-items-center gap-3 h-100">
    <button
      v-if="!hide_hamburger"
      :class="[
        'btn d-flex align-items-center justify-content-center p-0 border-0 bg-transparent',
        is_onboarding_system ? 'onboarding-mobile-menu-trigger' : 'd-lg-none'
      ]"
      @click="$emit('toggle-sidebar')"
      aria-label="Open menu"
    >
      <i class="bi bi-list fs-3 text-dark"></i>
    </button>

    <div class="onboarding-nav-title">
      <div class="text-uppercase text-muted onboarding-section-label">{{ onboarding_section }}</div>
      <div class="fw-bold text-black">{{ onboarding_title }}</div>
    </div>

    <div class="onboarding-nav-search d-none d-lg-flex align-items-center">
      <span class="onboarding-nav-search-icon">
        <i class="bi bi-search text-muted fs-6"></i>
      </span>
      <input
        type="text"
        class="onboarding-nav-search-input text-x"
        placeholder="Search onboardings, candidates, documents, templates"
      />
    </div>

    <span class="badge rounded onboarding-live-pill d-none d-lg-inline-flex align-items-center gap-2">
      <i class="bi bi-person"></i>
      <span>{{ current_onboarding_journey_label }}</span>
    </span>

    <div class="onboarding-nav-actions d-flex align-items-center">
      <PlatformSwitcher v-if="is_aic_one_login" current_platform_id="complyon_onboard" />

      <button
        v-if="!is_applicant_role"
        type="button"
        class="btn btn-outline-secondary text-xs d-none d-xl-inline-flex align-items-center gap-2 fw-semibold px-3"
      >
        <i class="bi bi-box-arrow-up-right"></i>
        Open Complyon
      </button>

      <button
        v-if="show_new_onboarding_action"
        type="button"
        class="btn btn-primary text-xs d-inline-flex align-items-center gap-2 fw-semibold px-3"
        @click="$emit('open-onboarding')"
      >
        <i class="bi bi-plus-lg"></i>
        New onboarding
      </button>

      <button type="button" class="btn btn-link text-dark p-0 d-inline-flex onboarding-nav-icon" aria-label="Notifications">
        <i class="bi bi-bell fs-4"></i>
      </button>

      <button
        type="button"
        class="btn btn-link text-dark p-0 d-inline-flex onboarding-nav-icon onboarding-ai-toggle d-xl-none"
        :aria-label="show_mobile_ai_drawer ? 'Close OnboardOS AI' : 'Open OnboardOS AI'"
        @click="$emit('toggle-ai-sidebar')"
      >
        <i class="bi" :class="show_mobile_ai_drawer ? 'bi-layout-sidebar-inset' : 'bi-stars'"></i>
      </button>

      <button type="button" class="btn btn-link text-dark p-0 d-inline-flex onboarding-nav-icon" @click="sign_out" aria-label="Sign out">
       <i class="bi bi-box-arrow-right fs-4"></i> 
      </button>

      <button
        type="button"
        class="btn p-0 border-0 bg-transparent onboarding-profile-trigger d-inline-flex"
        aria-label="View my profile"
        @click="open_profile_modal"
      >
        <span class="config-navbar-initials onboarding-navbar-initials rounded-circle d-inline-flex align-items-center justify-content-center fw-bold flex-shrink-0">
          {{ user_initials }}
        </span>
      </button>
    </div>

    
  </div>
</nav>

<nav v-else class="navbar navbar-expand-lg bg-white border-bottom border-purple border-opacity-50 px-3 px-lg-4 py-3">
  <div class="container-fluid px-0 d-flex align-items-center gap-3">
    <button
      v-if="!hide_hamburger"
      class="btn d-flex d-lg-none align-items-center justify-content-center p-0 border-0 bg-transparent"
      @click="$emit('toggle-sidebar')"
      aria-label="Open menu"
    >
      <i class="bi bi-list fs-3 text-dark"></i>
    </button>

    <div class="config-navbar-brand d-inline-flex align-items-center flex-shrink-0" aria-label="Workspace brand">
      <img :src="$clientLogo" alt="Logo" class="config-navbar-logo">
    </div>

    <div class="flex-grow-1"></div>

    <div class="ms-auto d-flex align-items-center gap-2 gap-lg-3">
      <div class="config-navbar-profile d-flex align-items-center">
        <div class="d-none d-md-flex align-items-center">
          <div class="input-group config-search">
            <span class="input-group-text border-0">
              <i class="bi bi-search"></i>
            </span>
            <input
              type="text"
              class="form-control form-control-sm border-0"
              placeholder="Search onboardings, requesters, panel members..."
            />
          </div>
        </div>

        <span class="config-navbar-divider d-none d-md-inline-flex" aria-hidden="true"></span>

        <a
          href="#"
          class="config-navbar-icon btn-link text-dark text-decoration-none d-inline-flex align-items-center justify-content-center"
          aria-label="Notifications"
        >
          <i class="bi bi-bell fs-5"></i>
        </a>

        <span class="config-navbar-divider" aria-hidden="true"></span>

        <PlatformSwitcher v-if="is_aic_one_login" current_platform_id="complyon_onboard" />

        <button
          type="button"
          class="config-navbar-user config-navbar-user-button text-dark text-decoration-none d-inline-flex align-items-center border-0 bg-transparent"
          aria-label="View my profile"
          @click="open_profile_modal"
        >
          <span class="config-navbar-initials rounded-circle d-inline-flex align-items-center justify-content-center fw-bold">
            {{ user_initials }}
          </span>
          <span class="config-navbar-name fw-semibold">{{ user_name }}</span>
        </button>
      </div>
    </div>
  </div>
</nav>

<UserProfileModal
  :visible="show_profile_modal"
  :is-loading="is_loading_profile"
  :is-editing="is_editing_profile"
  :is-saving="is_saving_profile"
  :can-edit="can_edit_profile"
  :error="profile_error"
  :save-error="profile_save_error"
  :profile="profile_modal_data"
  :edit-form="profile_edit_form"
  @close="close_profile_modal"
  @open-edit="open_profile_edit"
  @save="save_profile_edit"
  @update:first-name="profile_edit_form.first_name = $event"
  @update:last-name="profile_edit_form.last_name = $event"
  @update:phone-number="profile_edit_form.phone_number = $event"
  @sanitize-name="sanitize_profile_name"
  @sanitize-phone="sanitize_profile_phone"
/>
